import 'regenerator-runtime/runtime';
import { API_URL , RES_PER_PAGE, API_KEY } from './config';
import { AJAX } from './helpers'

export const state = {
    recipe: {},
    search:{
        query: '',
        results: [],
        searchResulsPerPage : RES_PER_PAGE,
        page: 1
    },
    bookMarks: []
}

const createRecipeObject = function(data){
    let { recipe } = data.data;
    return {
      id: recipe.id,
      title: recipe.title,
      publisher: recipe.publisher,
      sourceUrl: recipe.source_url,
      imageUrl: recipe.image_url,
      servings: recipe.servings,
      cookingTime: recipe.cooking_time,
      ingredients: recipe.ingredients,
      ...(recipe.key && {key: recipe.key})
    };
}

export const loadRecipe = async function(id){
try{
    const data = await AJAX(`${API_URL}${id}?key=${API_KEY}`);
    state.recipe = createRecipeObject(data);
    if(state.bookMarks.some(bookMark => bookMark.id === id)){
        state.recipe.bookmarked = true;
    }else{
        state.recipe.bookmarked = false;
    }

}catch(err){
    throw err;
}

}

export const loadSearchResults = async function(query){
    try{
        state.search.query = query;
        const data = await AJAX(`${API_URL}?search=${query}&key=${API_KEY}`);
        state.search.results = data.data.recipes.map(rec => {
            return {
                id:rec.id,
                title:rec.title,
                publisher: rec.publisher,
                imageUrl: rec.image_url,
                ...(rec.key && {key: rec.key})
           }
        });
        state.search.page = 1;
    }
    catch(err){
        throw err;
    }
}

export const getSearchResultsPage = function(page = state.search.page){
    state.search.page = page;
    let start = (page - 1) * state.search.searchResulsPerPage;
    let end = (page) * state.search.searchResulsPerPage;;
    return state.search.results.slice(start, end);
}

export const updateServings= function(newServings){
    state.recipe.ingredients.forEach(ing => {
        ing.quantity = ing.quantity * newServings / state.recipe.servings;
    });
    state.recipe.servings = newServings;    
}

export const addBookMark = function(recipe){
    state.bookMarks.push(recipe);
    if(recipe.id === state.recipe.id){
        state.recipe.bookmarked = true;
    };
    persistBokkmarks();
}

export const deleteBookmark = function(id){
    const index = state.bookMarks.findIndex(el => el.id === id);
    state.bookMarks.splice(index,1);
    if(id === state.recipe.id){
        this.state.recipe.bookmarked = false;
    };
    persistBokkmarks();
}

const persistBokkmarks = function(){
    localStorage.setItem('bookmarks', JSON.stringify(state.bookMarks))
}

const init = function(){
    const storage = localStorage.getItem('bookmarks');
    if(storage) state.bookMarks = JSON.parse(storage);
}
init();

const clearBookMarks = function(){
    localStorage.clear('bookmarks');
}

export const uploadRecipe = async function(newRecipe){
    try{
    const ingredients = Object.entries(newRecipe).filter(entry => entry[0].startsWith('ingredient') && entry[1] !== '').
    map(ing =>{
        const ingArr = ing[1].trim().split(',');
        if(ingArr.length !== 3) throw new Error('wrong ingredient format! please, use correct format')
        const [quantity,unit,description]= ingArr;
        return {quantity: quantity ? +quantity : null ,unit,description};
    });

    const recipe = {
        title: newRecipe.title,
        source_url: newRecipe.sourceUrl,
        image_url: newRecipe.image,
        publisher: newRecipe.publisher,
        cooking_time: +newRecipe.cookingTime,
        servings: +newRecipe.servings,
        ingredients,
      };

     const data = await AJAX(`${API_URL}?key=${API_KEY}`, recipe);
     state.recipe = createRecipeObject(data);
     addBookMark(state.recipe)
    
} catch (err){
    throw err;
}
}